<section class="container-fluid next-race-section upper-section-background">
  <div class="container">
    <section>
      <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3">
        <div class="col mb-4">
          <app-event-grid-item-with-image (click)="goToEventDetailsPage()" [eventItem]="event" [countries]="countries"
                                          [languages]="languages" [isPreviewComponent]="isPreviewComponent"/>
        </div>
      </div>
    </section>
  </div>
</section>
